import { useContext, useCallback } from 'react';
import _get from 'lodash/get';
import _filter from 'lodash/filter';
import _find from 'lodash/find';
import { AjaxContext, AppContext, UserContext, formatListData } from 'commons-ui';
import { PAGE_NAMES, BULK_ACTIONS_RESOURCES, ACTION } from 'constant';

const useService = () => {
	const { postData } = useContext(AjaxContext);
	const {
		app: { appName, isGold }
	} = useContext(AppContext);
	const { permissionsConfig } = useContext(UserContext);
	const getAllCoupons = useCallback(
		async ({ pageDetails, sortDetails, filterDetails }: { pageDetails: any; sortDetails: any; filterDetails: any }) => {
			const permission = _find(permissionsConfig, { actionName: ACTION.getCoupons });
			const getCouponsResult = await postData({
				endpoint: `/dashboard/getCoupons/${PAGE_NAMES.bulkActions}-${BULK_ACTIONS_RESOURCES.allCoupons}-getCoupons`,
				queryParams: {
					appName
				},
				body: {
					page: pageDetails,
					filters: filterDetails,
					sortInfoArray: sortDetails,
					isPartnerCoupon: false,
					isGold
				},
				customHeaders: {
					isMasked: permission?.isMasked || false
				}
			});

			let listData = formatListData(getCouponsResult?.data?.coupons);
			listData = _filter(listData, (row) => !_get(row, 'isPartnerCoupon', false));
			return { rowCount: getCouponsResult?.data?.count, data: listData };
		},
		[]
	);

	return {
		getAllCoupons
	};
};

export default useService;
